/**
 * 格式化
 * 
 * @param {String} str
 * @returns 格式化后
 */
export const head = function (_url) {
    if (_url == '') {
        return '/static/uploads/default_head.png';
    } else {
        return _url + '_0.jpg';
    }
}

export const decorateTime = function (_start, _stop) {

    /**
     *     [info]时间修饰[info]
     *
     *     [param]开始时间，结束时间[param]
     */

    function timeWrap(_value) {
        if (_value < 10) {
            return '0' + _value;
        } else {
            return _value;
        }
    }

    function formateDate(_date) {
        return timeWrap(_date.getHours()) + ':' + timeWrap(_date.getMinutes()) + ':' + timeWrap(_date.getSeconds());
    }

    function validate(s_date, e_date) {
        //alert(s_date.getFullYear() +' ' + s_date.getMonth() + ' ' + s_date.getDate() + '\n' + e_date.getFullYear() +' ' + e_date.getMonth() + ' ' + e_date.getDate());
        return s_date.getFullYear() == e_date.getFullYear() && s_date.getMonth() == e_date.getMonth() && s_date.getDate() == e_date.getDate();
    }

    var end = _stop - _start;

    var this_date = new Date(),
        now_date = new Date(),
        tomorrow_date = new Date();
    this_date.setTime(_start * 1000);
    tomorrow_date.setTime((_start + 86400) * 1000);
    now_date.setTime(_stop * 1000);

    //error
    if (end <= 0) {
        return '刚刚';
    }

    //today
    if (validate(this_date, now_date)) {
        return '今天 ' + formateDate(this_date);
    }

    //yesterday
    if (validate(tomorrow_date, now_date)) {
        return '昨天 ' + formateDate(this_date);
    }
    return this_date.getFullYear() + '-' + (this_date.getMonth() + 1) + '-' + this_date.getDate() + ' ' + formateDate(this_date);
}

export const beFrom = function(app, version){
    var appType = app&&app.appType || app;
    version = version || '';
    var returnText = '&nbsp;&nbsp;&nbsp;';
    switch(appType){
        case 'web':
            returnText += '来自&nbsp;&nbsp;期货圈网页版';
        break;
        case 'android':
            returnText += ('来自&nbsp;&nbsp;安卓随身行&nbsp;&nbsp;'+ version);
        break;
        case 'ios':
            returnText += ('来自&nbsp;&nbsp;苹果随身行&nbsp;&nbsp;'+ version);
        break;
        default:
            returnText += '';
    }
    return returnText;
}